export default "__VITE_ASSET__C8Ve4Bth__"